'use strict';

import { Cloudflare } from '../api/Cloudflare';
import {
	Color,
	FloatType,
	Group,
	LinearFilter,
	LinearSRGBColorSpace,
	LoadingManager,
	Mesh,
	MeshBasicMaterial,
	NearestFilter,
	PlaneGeometry,
	RGBAFormat,
	ShaderMaterial,
	TextureLoader,
	Vector2,
	WebGLRenderTarget,
} from 'three';
import { Buildings, isDesktop, isMobile, projectMode, resourcesFolder, threeJsVariables } from '../../settings';
import vertex from '../threejs/Shaders/Rotor/vertex.glsl';
import fragment from '../threejs/Shaders/Rotor/fragment.glsl';
import { getCanvasWidthDiff } from '../../app';
import { CSS2DObject } from '../../libs/CSS2DRenderer';
import { getBuildingLabel, labelContainerClickHandler } from '../components/building-switch/buildingLabels';

const _color = new Color();
const _vec2 = new Vector2();
const _tl = new TextureLoader();

const DEFAULT_PARAMS = {
	images: [],
	startImage: 0,
	dragTolerance: 10,
	highResolutionTimeout: 800,
	invert: false
};

const LOW_RESOLUTION_SETTINGS = {
	width: isDesktop ? 1024 : isMobile ? 512 : 512
};

export class Rotor {
	#dragOrigin;
	#lazyLoading = null;
	#lazyProgress = 0;

	constructor (scope,loader) {
		this.liteMode = scope;
		this.resources = `${this.liteMode.resourcesUrl}rotor`;
		this.enabled = true;
		this.highResolutuion = {
			web: `${config.cdnRepository}/resize/image/width=4000/${config.projectFolder}/${resourcesFolder}/litemod/rotor`,
			mobile: `${config.cdnRepository}/resize/image/width=2000/${config.projectFolder}/${resourcesFolder}/litemod/rotor`,
			desktop: `${config.cdnRepository}/resize/image/width=4000/$${config.projectFolder}/${resourcesFolder}/litemod/rotor`
		};

		this.config = null;
		this.slides = null;
		this.mapping = [];
		this.labels = {};
		this.activeLabel = null;
		this.currentIndex = 0;
		this.selectedBuilding = null;
		this.timeout = null;
		this.pressed = false;
		this.move = false;
		this.coords = {
			down: new Vector2(),
			up: new Vector2(),
			point: new Vector2()
		};
		this.size = {
			width: 0,
			height: 0
		};
		this.pixel = {
			x: 0,
			y: 0
		};

		this.selectionMaterial = new ShaderMaterial({
			vertexShader: vertex,
			fragmentShader: fragment,
			uniforms: {
				highlightsMap: {value: null},
				visible: {value: false},
				color: {value: new Color()}
			},
			depthTest: false,
			depthWrite: false,
			transparent: true
		});
		this.selections = new Mesh(new PlaneGeometry(2,2,1,1),this.selectionMaterial);
		this.selections.position.set(0,0,-0.2);
		this.selections.name = 'selections layer';
		this.liteMode.overlay.add(this.selections);

		this.colorBuffer = new Float32Array(4);
		this.selectionIntersect = new Mesh(new PlaneGeometry(2,2,1,1),new MeshBasicMaterial());
		this.selectionsRT = new WebGLRenderTarget(1,1,{
			minFilter: LinearFilter,
			magFilter: NearestFilter,
			format: RGBAFormat,
			type: FloatType
		});
		this.liteMode.overlay.add(this.selectionIntersect);
		this.mainLoader = loader;
		this.swap = {
			highResolutionSlide: null,
			lowResolutionSlide: null
		};
		
		// const fileLoader = loader.fileLoader;
		// const textureLoader = loader.textureLoader;


		// const highTextureManager = new LoadingManager(() => {
		// 	const loadedAllSlides = this.#lazyLoading.every(slide => slide.loaded);
		// 	if (loadedAllSlides) {
		// 		this.#lazyProgress = 100;
		// 		this.#lazyLoading = null;
		// 	}
		// });
		// const highTextureLoader = new TextureLoader(highTextureManager);

		threeJsVariables.renderer.domElement.addEventListener('pointerdown',this.#pointerDown.bind(this));
		threeJsVariables.renderer.domElement.addEventListener('pointerup',this.#pointerUp.bind(this));
		threeJsVariables.renderer.domElement.addEventListener('pointermove',this.#pointerMove.bind(this));
		threeJsVariables.renderer.domElement.addEventListener('touchstart',this.#touchStart.bind(this));
		threeJsVariables.renderer.domElement.addEventListener('touchmove',this.#touchMove.bind(this));
		threeJsVariables.renderer.domElement.addEventListener('touchend',this.#touchEnd.bind(this));

		// loader.addCallback = () => this.start();

		// fileLoader.load(`${this.resources}/rotor.json?v=${Cloudflare.version}`,(cfg) => {
		// 	this.config = Object.assign({},DEFAULT_PARAMS,JSON.parse(cfg));
		//
		// 	this.currentIndex = this.config.startImage;
		// 	const startSlide = this.config.images[this.config.startImage];
		//
		// 	this.slides = new Array(this.config.images.length);
		// 	this.#lazyLoading = new Array(this.config.images.length);
		// 	this.#parseMapping();
		//
		// 	this.slides[this.config.startImage] = this.#loadSlide(startSlide,'high',textureLoader,(texture) => {
		// 		texture.colorSpace = LinearSRGBColorSpace;
		// 		this.size.width = texture.image.width;
		// 		this.size.height = texture.image.height;
		// 		this.liteMode.imageWidth = this.size.width;
		// 		this.liteMode.imageHeight = this.size.height;
		// 		this.liteMode.updateAspect();
		// 		this.liteMode.resizeContainer();
		// 	});
		//
		// 	this.config.images.forEach((slide,index) => {
		// 		if (index !== this.config.startImage) {
		// 			this.slides[index] = this.#loadSlide(slide,'low',textureLoader,(texture) => {
		// 				texture.colorSpace = LinearSRGBColorSpace;
		// 			});
		//
		// 			this.#lazyLoading[index] = {
		// 				loaded: false,
		// 				pending: false,
		// 				callback: () => {
		// 					if (!this.#lazyLoading[index].pending) {
		// 						this.#lazyLoading[index].pending = true;
		// 						const highResolutionSlide = this.#loadSlide(slide,'high',highTextureLoader,(texture) => {
		// 							texture.colorSpace = LinearSRGBColorSpace;
		// 							let oldSlide = this.slides[index];
		// 							this.#disposeSlide(oldSlide);
		// 							oldSlide = null;
		// 							this.slides[index] = highResolutionSlide;
		// 							this.#lazyLoading[index].loaded = true;
		// 							if (index === this.currentIndex) {
		// 								this.render();
		// 							}
		// 						});
		// 					}
		// 				}
		// 			}
		// 		} else {
		// 			this.#lazyLoading[index] = {loaded: true, callback: null, pending: true};
		// 		}
		// 	});
		// });
	}

	#hoverIn(color) {
		this.selectedBuilding = this.#findSelected(color);
		if (this.selectedBuilding) {
			this.selectionMaterial.uniforms.color.value.copy(color);
			this.selectionMaterial.uniforms.visible.value = true;
			threeJsVariables.renderer.domElement.style.cursor = 'pointer';
			if (this.selectedBuilding.buildingEngineId !== this.activeLabel?.userData.buildingEngineId) {
				this.#labelHoverToggle(false,this.activeLabel);
			}
			this.activeLabel = this.labels[this.selectedBuilding.buildingEngineId];
			this.#labelHoverToggle(true,this.activeLabel);
		}
	}

	#labelHoverToggle(state,label) {
		if (label) {
			if (state) {
				label.element.querySelector('.building-labels_wrapper').classList.add('building__hovered');
			} else {
				label.element.querySelector('.building-labels_wrapper').classList.remove('building__hovered');
			}
		}
	}

	#findSelected(color) {
		const distances = this.mapping.map(data => this.#calculateDistance(data.color,color));
		const min = Math.min(...distances);
		if (min < 0.05) {
			const index = distances.indexOf(min);
			return this.mapping[index];
		}
		return  null;
	}

	#calculateDistance(c1,c2) {
		return Math.sqrt((c1.r - c2.r) ** 2 + (c1.g - c2.g) ** 2 + (c1.b - c2.b) ** 2);
	}

	#hoverOut() {
		this.selectionMaterial.uniforms.visible.value = false;
		this.selectedBuilding = null;
		threeJsVariables.renderer.domElement.style.cursor = '';
		this.#labelHoverToggle(false,this.activeLabel);
		this.activeLabel = null;
	}

	#parseMapping() {
		this.config.mapping.forEach(mapping => {
			const data = JSON.parse(JSON.stringify(mapping));
			data.color = new Color().fromArray(data.color);
			this.mapping.push(data);
		});
	}

	#loadSlide(slide,resolution,loader,callback) {
		let url;
		if (resolution === 'high') {
			url = isDesktop ? this.highResolutuion.desktop : isMobile ? this.highResolutuion.mobile : this.highResolutuion.web;
		} else {
			url = Cloudflare.resize(this.resources,LOW_RESOLUTION_SETTINGS,false,false);
		}

		const loadedSlide = {};

		Object.entries(slide).forEach(([key,value]) => {
			loadedSlide[key] = loader.load(`${url}/${value}?v=${Cloudflare.version}`,(texture) => {
				threeJsVariables.renderer.initTexture(texture);
				texture.colorSpace = LinearSRGBColorSpace;
				if (callback) {
					callback(key,texture);
				}
			});
		});

		return loadedSlide;
	}

	#disposeSlide(slide) {
		Object.values(slide).forEach(texture => texture.dispose());
	}

	enable(state) {
		this.enabled = state;
		this.selections.visible = state;
		this.selectionIntersect.visible = state;
		this.#hoverOut();
	}

	#calculatePointer(x,y) {
		const canvasSize = threeJsVariables.renderer.getSize(_vec2);
		const canvasDiff = getCanvasWidthDiff();
		this.coords.point.x = ((x - canvasDiff.x) / canvasSize.x) * 2 - 1;
		this.coords.point.y = -(y / canvasSize.y) * 2 + 1;
	}

	#pointerDown(e) {
		if (!this.enabled || e.pointerType === 'touch')
			return;

		if (e.button === 0) {
			this.#dragOrigin = e.pageX;
			this.coords.down.set(e.pageX,e.pageY);
		}

		this.pressed = true;
	}

	#pointerUp(e) {
		if (!this.enabled || e.pointerType === 'touch')
			return;

		this.#dragOrigin = null;

		if (e.button === 0) {
			this.coords.up.set(e.pageX,e.pageY);

			if (this.coords.down.equals(this.coords.up)) {
				this.#click();
			}
		}

		this.pressed = false;

		// if (this.#lazyProgress !== 100) {
		// 	this.#loadSiblingSlides(this.currentIndex);
		// }
	}

	#pointerMove(e) {
		if (!this.enabled || e.pointerType === 'touch')
			return;

		if (this.#dragOrigin && Math.abs(this.#dragOrigin - e.pageX) > this.config.dragTolerance) {
			this.#dragOrigin > e.pageX ? this.prev() : this.next();
			this.#dragOrigin = e.pageX;
		} else if (!this.pressed) {
			this.pixel.x = threeJsVariables.renderer.domElement.width / 2 + threeJsVariables.mouse.x * threeJsVariables.renderer.domElement.width / 2;
			this.pixel.y = threeJsVariables.renderer.domElement.height / 2 + threeJsVariables.mouse.y * threeJsVariables.renderer.domElement.height / 2;
			this.#intersectSelection();
		}
	}

	resize() {
		this.selectionsRT.setSize(threeJsVariables.renderer.domElement.width,threeJsVariables.renderer.domElement.height);
	}

	#intersectSelection() {
		threeJsVariables.renderer.setRenderTarget(this.selectionsRT);
		threeJsVariables.renderer.render(this.selectionIntersect,this.liteMode.camera);
		threeJsVariables.renderer.setRenderTarget(null);
		threeJsVariables.renderer.readRenderTargetPixels(this.selectionsRT,this.pixel.x,this.pixel.y,1,1,this.colorBuffer);

		if (this.colorBuffer[0] !== 0 || this.colorBuffer[1] !== 0 || this.colorBuffer[2] !== 0) {
			_color.set(this.colorBuffer[0],this.colorBuffer[1],this.colorBuffer[2]);
			this.#hoverIn(_color);
		} else {
			this.#hoverOut();
		}
	}

	#touchStart(e) {
		if (!this.enabled)
			return;

		if (e.touches.length === 1) {
			this.#dragOrigin = e.touches[0].pageX;
			this.coords.down.set(e.touches[0].pageX,e.touches[0].pageY);
			this.pressed = true;
		}
	}

	#touchEnd(e) {
		if (!this.enabled)
			return;

		this.#dragOrigin = null;
		this.pressed = false;
		this.move = false;

		if (e.changedTouches.length === 1) {
			this.coords.up.set(e.changedTouches[0].pageX,e.changedTouches[0].pageY);
			if (this.coords.down.equals(this.coords.up)) {
				this.#calculatePointer(this.coords.down.x,this.coords.down.y);
				this.pixel.x = threeJsVariables.renderer.domElement.width / 2 + this.coords.point.x * threeJsVariables.renderer.domElement.width / 2;
				this.pixel.y = threeJsVariables.renderer.domElement.height / 2 + this.coords.point.y * threeJsVariables.renderer.domElement.height / 2;
				this.#intersectSelection();
				this.#click();
			} else {
				this.loadHighResolutionSlide();
			}
		}

		
		// if (this.#lazyProgress !== 100) {
		// 	this.#loadSiblingSlides(this.currentIndex);
		// }
	}

	#touchMove(e) {
		if (!this.enabled)
			return;

		if (e.touches.length === 1) {
			if (this.#dragOrigin && Math.abs(this.#dragOrigin - e.touches[0].pageX) > this.config.dragTolerance) {
				if (!this.move) {
					this.disposeHighResolutionSlide();
				}
				this.move = true;
				this.#dragOrigin > e.touches[0].pageX ? this.prev() : this.next();
				this.#dragOrigin = e.touches[0].pageX;
			}
		}
	}

	#click() {
		if (this.selectedBuilding) {
			const building = Buildings.getBuilding(this.selectedBuilding.buildingEngineId);
			projectMode.Cylinder.enter(building);
		}
	}

	runLazyLoading() {
		if (!this.enabled)
			return;

		const forward = (index) => {
			if (index < this.slides.length) {
				this.#loadSiblingSlides(index + 2);
				setTimeout(() => forward(index + 2),0);
			}
		}
		const backward = (index) => {
			if (index > 0) {
				this.#loadSiblingSlides(index - 2);
				setTimeout(() => backward(index - 2),0);
			}
		}

		forward(this.currentIndex);
		backward(this.currentIndex);
	}

	#loadSiblingSlides(index) {
		if (!this.#lazyLoading)
			return;

		const center = this.#lazyLoading[index];
		const left = this.#lazyLoading[index - 1];
		const right = this.#lazyLoading[index + 1];

		if (center && !center.loaded && !center.pending) {
			center.callback();
		}

		if (left && !left.loaded && !left.pending) {
			left.callback();
		}

		if (right && !right.loaded && !right.pending) {
			right.callback();
		}
	}

	render() {
		this.currentIndex = (this.slides.length + this.currentIndex) % this.slides.length;

		const slide = this.slides[this.currentIndex];
		if (slide) {
			this.liteMode.material.uniforms.generalTexture.value = slide.general;
			this.selectionMaterial.uniforms.highlightsMap.value = slide.selections;
			// this.selectionMaterial.uniforms.highlightsMap.value = this.selectionsRT.texture;

			if (slide.selections) {
				this.selectionIntersect.material.map = slide.selections;
				this.selectionIntersect.material.color.set(1,1,1);
			} else {
				this.selectionIntersect.material.map = null;
				this.selectionIntersect.material.color.set(0,0,0);
			}
		}
		this.updateLabels();
	}

	next() {
		this.currentIndex = this.config.invert ? this.currentIndex - 1 : this.currentIndex + 1;
		this.render();
	}

	prev() {
		this.currentIndex = this.config.invert ? this.currentIndex + 1 : this.currentIndex - 1;
		this.render();
	}

	initLabels() {
		if (config.features.liteMode.rotorLabels === false) {
			return;
		}
		const buildings = Buildings.getBuildingsArray();
		const colors = config.threejs.label.colors || {};
		const hideClickHere = config.threejs.label.hideClickHere;
		const scopeGroup = this.liteMode.group;
		const labelGroup = new Group();
		labelGroup.name = 'Labels';
		scopeGroup.add(labelGroup);
		const zoomRule = config.threejs.label.size || 0.6;

		buildings.forEach(building => {

			if (!Object.keys(building.info).length) return;

			const labelTowerNumber = building.info.labelName;
			const labelContainer = document.createElement('div');
			labelContainer.className = 'building-labels';
			labelContainer.setAttribute('data-attribute', labelTowerNumber);
			const buildingColor = building.info.color;
			const labelBGColor = Boolean(buildingColor)
				? buildingColor
				: undefined;

			if (building.info.buildingIcon.length) {
				labelContainer.innerHTML = `
        <div class='building-labels_wrapper ${hideClickHere ? 'hide-click-here' : 'show-click-here'}' data-name="${building.name}" data-label="labelTower-${building.info.labelName}">
            <div class="building-label-bubble">${getBuildingLabel(labelBGColor)}</div>
            <div class="building-labels__icon" style="background: url(${building.info.buildingIcon})"></div>
        </div>
        `;

			} else {

				labelContainer.innerHTML = `
            <div class='building-labels_wrapper ${hideClickHere ? 'hide-click-here' : 'show-click-here'}' data-name="${building.name}" data-label="labelTower-${building.info.labelName}">
                <div class="building-label-bubble">${getBuildingLabel(labelBGColor)}</div>
                <span>${labelTowerNumber}</span>
            </div>
            `;
			}

			if (colors.text) {
				labelContainer.querySelector('.building-labels_wrapper').style = `color: ${colors.text}`;
			}

			labelContainer.classList.add('active');
			const label = new CSS2DObject(labelContainer);
			label.name = `labelTower-${building.info.labelName}`;
			label.userData.buildingEngineId = building.name;
			labelContainer.addEventListener('click', labelContainerClickHandler);

			if (config.features.liteMode.settings.buildingLabelDiff) {
				label.userData.zoom = 1 - config.features.liteMode.settings.buildingLabelDiff;
			} else {
				label.userData.zoom = zoomRule;
			}

			labelGroup.add(label);
			this.labels[building.name] = label;
		});
		this.updateLabels();
	}

	updateLabels() {
		if (Object.keys(this.labels).length === 0)
			return;
		
		const data = this.config.labels[this.currentIndex];
		if (!this.enabled) {
			Object.entries(this.labels).forEach(([name,label]) => {
				const labelPosition = data[name];
				label.element.classList.add('hidden');
				label.position.set(labelPosition[0],labelPosition[1],0)
			});
			return;
		}

		Object.entries(this.labels).forEach(([name,label]) => {
			const labelPosition = data[name];
			if (labelPosition.length === 0) {
				label.element.classList.add('hidden');
			} else {
				label.element.classList.remove('hidden');
				label.position.set(labelPosition[0],labelPosition[1],0)
			}
		});
	}

	init(cfg) {
		const textureLoader = this.mainLoader.textureLoader;
		// const highTextureManager = new LoadingManager(() => {
		// 		// 	const loadedAllSlides = this.#lazyLoading.every(slide => slide.loaded);
		// 		// 	if (loadedAllSlides) {
		// 		// 		this.#lazyProgress = 100;
		// 		// 		this.#lazyLoading = null;
		// 		// 	}
		// 		// });
		// const highTextureLoader = new TextureLoader(highTextureManager);

		this.mainLoader.addCallback = () => this.start();
		this.config = Object.assign({},DEFAULT_PARAMS,JSON.parse(cfg));

		this.currentIndex = this.config.startImage;
		const startSlide = this.config.images[this.config.startImage];

		this.slides = new Array(this.config.images.length);
		// this.#lazyLoading = new Array(this.config.images.length);
		this.#parseMapping();

		this.slides[this.config.startImage] = this.#loadSlide(startSlide, 'high', textureLoader, (key,texture) => {
			if (key === 'general') {
				this.size.width = texture.image.width;
				this.size.height = texture.image.height;
				this.liteMode.imageWidth = this.size.width;
				this.liteMode.imageHeight = this.size.height;
				this.liteMode.updateAspect();
				this.liteMode.resizeContainer();
			}
		});

		this.config.images.forEach((slide, index) => {
			if (index !== this.config.startImage) {
				this.slides[index] = this.#loadSlide(slide, 'low', textureLoader);

				// this.#lazyLoading[index] = {
				// 	loaded: false,
				// 	pending: false,
				// 	callback: () => {
				// 		if (!this.#lazyLoading[index].pending) {
				// 			this.#lazyLoading[index].pending = true;
				// 			const highResolutionSlide = this.#loadSlide(slide, 'high', highTextureLoader, (texture) => {
				// 				texture.colorSpace = LinearSRGBColorSpace;
				// 				let oldSlide = this.slides[index];
				// 				this.#disposeSlide(oldSlide);
				// 				oldSlide = null;
				// 				this.slides[index] = highResolutionSlide;
				// 				this.#lazyLoading[index].loaded = true;
				// 				if (index === this.currentIndex) {
				// 					this.render();
				// 				}
				// 			});
				// 		}
				// 	},
				// };
			}
			// else {
				// this.#lazyLoading[index] = {loaded: true, callback: null, pending: true};
			// }
		});
	}
	
	disposeHighResolutionSlide() {
		if (this.swap.highResolutionSlide) {
			this.slides[this.currentIndex] = this.swap.lowResolutionSlide;
			this.#disposeSlide(this.swap.highResolutionSlide);
			this.swap.highResolutionSlide = null;
			this.render();
		}
		
		if (this.timeout) {
			clearTimeout(this.timeout);
		}
	}
	
	loadHighResolutionSlide() {
		if (this.currentIndex !== this.config.startImage) {
			const index = this.currentIndex;
			this.timeout = setTimeout(() => {
				const slide = this.#loadSlide(this.config.images[this.currentIndex],'high',_tl,(key,texture) => {
					if (index === this.currentIndex) {
						if (key === 'general') {
							this.swap.lowResolutionSlide = this.slides[index];
							this.swap.highResolutionSlide = slide;
							this.slides[index] = slide;
							this.render();
						}
					} else {
						texture.dispose();
					}
				});
			},this.config.highResolutionTimeout);
		}
	}

	start() {
		this.render();
		// this.#loadSiblingSlides(this.currentIndex);
	}

}
